import { COMPLETE_STEP } from 'event-user/constants/EventUserSetupSteps';
import { APP_ROUTES } from 'shared/constants/navigation';

const RequireEventProfileStarted = (context) => {
    if (context.store.event.CurrentStep !== COMPLETE_STEP) {
        if (context.store.event.CurrentStep === null) {
            console.log('null', context.store.event);
            context.store.event.CurrentStep = 'event-basics';
        }
        return APP_ROUTES.setup;
    }
    return 'next';
};

export { RequireEventProfileStarted };
